import React from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import Footer from './Footer';
import { useMobileNav } from '../contexts/MobileNavContext';

const Layout = ({ children }) => {
    const { isSidebarCollapsed } = useMobileNav();

    return (
        <div className="flex min-h-screen">
            {/* Sidebar - desktop fixed, mobile is drawer overlay */}
            <Sidebar />

            {/* Main content area - add left margin on desktop to account for fixed sidebar */}
            <div className={`flex-1 flex flex-col min-h-screen w-full transition-all duration-300 ${isSidebarCollapsed ? 'md:ml-20' : 'md:ml-64'}`}>
                {/* Header - sticky on top */}
                <Header />

                {/* Page content - naturally scrollable with safe area padding */}
                <main className="flex-1 bg-gray-50 pb-safe">
                    {children}
                </main>

                {/* Footer */}
                <Footer />
            </div>
        </div>
    );
};

export default Layout;